export default function SectionContact() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            投稿合作
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            欢迎漫画创作者与版权方联系我们
          </p>
        </div>
        <div className="max-w-2xl mx-auto">
          <div className="bg-background-50 rounded-2xl p-8 md:p-10">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 text-center">
              <div className="flex flex-col items-center gap-3">
                <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center">
                  <i className="ri-mail-line text-xl text-primary-600"></i>
                </div>
                <h3 className="font-heading text-sm font-semibold text-foreground-900">商务合作</h3>
                <p className="text-xs text-foreground-500">business@chongchong.com</p>
              </div>
              <div className="flex flex-col items-center gap-3">
                <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center">
                  <i className="ri-file-copy-line text-xl text-accent-600"></i>
                </div>
                <h3 className="font-heading text-sm font-semibold text-foreground-900">漫画投稿</h3>
                <p className="text-xs text-foreground-500">submit@chongchong.com</p>
              </div>
              <div className="flex flex-col items-center gap-3">
                <div className="w-12 h-12 rounded-xl bg-secondary-100 flex items-center justify-center">
                  <i className="ri-question-answer-line text-xl text-secondary-600"></i>
                </div>
                <h3 className="font-heading text-sm font-semibold text-foreground-900">版权咨询</h3>
                <p className="text-xs text-foreground-500">copyright@chongchong.com</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}